import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "gap"];
import styled from 'styled-components';
import { LayoutHorizontal } from '../Layout/LayoutHorizontal';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTagGroup = styled(LayoutHorizontal).withConfig({
  displayName: "TagGroup__StyledTagGroup",
  componentId: "ojre18-0"
})(["> span + span{margin-inline-start:0 !important;}"]);
export const TagGroup = _ref => {
  let {
      children,
      gap = 'space-xs'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledTagGroup, Object.assign({}, rest, {
    gap: gap,
    children: children
  }));
};